
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("7Clnv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2307c23eea04d7f$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $9OWP7 = parcelRequire("9OWP7");

var $fqDmW = parcelRequire("fqDmW");

var $bt1Sd = parcelRequire("bt1Sd");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");

var $dmC2D = parcelRequire("dmC2D");

var $9w0eB = parcelRequire("9w0eB");

var $cLysE = parcelRequire("cLysE");

var $31nHY = parcelRequire("31nHY");

var $lnbpL = parcelRequire("lnbpL");

var $j7UeI = parcelRequire("j7UeI");

var $jthWj = parcelRequire("jthWj");

var $gtKO2 = parcelRequire("gtKO2");

var $fYxRW = parcelRequire("fYxRW");

var $1V2cH = parcelRequire("1V2cH");

var $1UkGo = parcelRequire("1UkGo");

var $cZAbO = parcelRequire("cZAbO");

var $6eNI5 = parcelRequire("6eNI5");

var $cs6gC = parcelRequire("cs6gC");

var $brCu8 = parcelRequire("brCu8");

var $83IjZ = parcelRequire("83IjZ");

var $9X0U9 = parcelRequire("9X0U9");
var $c32T7 = parcelRequire("c32T7");

var $5v178 = parcelRequire("5v178");
const $a2307c23eea04d7f$export$d55ce944e082b58f = (0, $fqDmW.default).div`
  align-items: center;
  color: ${(0, $kLNLK).N90};
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 0 8px;
`;
const $a2307c23eea04d7f$export$a7fed597f4b8afd8 = (0, $fqDmW.default).form`
  margin: 0;
`;
const $a2307c23eea04d7f$var$InputsWrapper = (0, $fqDmW.default).div`
  margin-bottom: ${(0, $6e88g.gridSize)()}px;
`;
const $a2307c23eea04d7f$var$getEmailFieldViewType = (restrictedEmail, redirectType, isSecondStep, isLoading)=>{
    if (restrictedEmail || redirectType === (0, $gtKO2.CheckUserNameRedirectType).Sso) return (0, $dmC2D.FieldViewType).Restricted;
    else if (isSecondStep || isLoading) return (0, $dmC2D.FieldViewType).ReadOnlyWithEditButton;
    return (0, $dmC2D.FieldViewType).Editable;
};
const $a2307c23eea04d7f$export$1f58f750f20f344b = ({ application: application, email: email, error: error, fieldErrors: fieldErrors, info: info, isLoading: isLoading, isPasswordlessAllowed: isPasswordlessAllowed, isRedirecting: isRedirecting, isSecondStep: isSecondStep, isCheckUsernameLoading: isCheckUsernameLoading, onContinue: onContinue, onEditEmail: onEditEmail, onEmailChange: onEmailChange, onFormClick: onFormClick, onLogIn: onLogIn, onPasswordlessLogIn: onPasswordlessLogIn, onValidationError: onValidationError, pageId: pageId, redirectType: redirectType, restrictedEmail: restrictedEmail, showRememberMeCheckbox: showRememberMeCheckbox, rememberMeChecked: rememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox })=>{
    const intl = (0, $leG06.default)();
    const translatedEmailFieldError = (0, $brCu8.useTranslateFormErrorIfAvailable)(fieldErrors.email);
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const [password, setPassword] = (0, $91i6m.useState)("");
    const [buttonClicked, setButtonClicked] = (0, $91i6m.useState)("submit");
    const inputRef = (0, $91i6m.useRef)(null);
    const [passwordFieldError, setPasswordFieldError] = (0, $91i6m.useState)(null);
    const onEmailClick = (0, $91i6m.useCallback)(()=>{
        setPassword("");
        setPasswordFieldError(null);
        onEditEmail();
    }, [
        onEditEmail
    ]);
    const { captchaValue: captchaValue, isRequired: isTooManyAttemptsRecaptchaRequired } = (0, $6eNI5.useLoginTooManyAttemptsRecaptchaContext)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        const trimmedEmail = email.trim();
        const emailEmpty = trimmedEmail === "";
        const passwordEmpty = password === "";
        // Ignore submission of form while the app is loading.
        if (isLoading) return;
        if (emailEmpty) {
            inputRef.current?.focus();
            const emailValidationError = formatMessage((0, $jthWj.default).emailEmpty);
            analyticsClient.errorShownEvent((0, $1UkGo.pageId), "validationError");
            onValidationError({
                email: emailValidationError
            });
        }
        setButtonClicked("submit");
        if (!isSecondStep) {
            analyticsClient.buttonClickedEvent(pageId, "continueToLogin");
            if (!emailEmpty) onContinue(trimmedEmail);
        } else {
            analyticsClient.buttonClickedEvent(pageId, "login");
            if (passwordEmpty) setPasswordFieldError(formatMessage((0, $jthWj.default).passwordEmpty));
            else if (!emailEmpty) onLogIn(trimmedEmail, password);
        }
    };
    const handlePasswordlessButtonClick = async ()=>{
        const trimmedEmail = email.trim();
        if (isLoading || !trimmedEmail) return;
        setButtonClicked("passwordless");
        onPasswordlessLogIn(trimmedEmail);
    };
    const handlePasswordChange = (0, $91i6m.useCallback)((e)=>{
        if (passwordFieldError) setPasswordFieldError(null);
        setPassword(e.currentTarget.value);
    }, [
        passwordFieldError,
        setPasswordFieldError,
        setPassword
    ]);
    const buttonContent = ()=>{
        if (!isSecondStep) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "login.form.continue",
            defaultMessage: "Continue"
        });
        if (isPasswordlessAllowed) return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "common.login.with.password",
            defaultMessage: "Log in with password"
        });
        return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
            id: "common.login",
            defaultMessage: "Log in"
        });
    };
    const infoContent = ()=>{
        const { formatMessage: formatMessage } = intl;
        const applicationName = application ? (0, $fYxRW.applications)[application].name : "Product";
        const testId = "login-info-test-id";
        if (info) switch(info.code){
            case "migratingExistingUser":
                {
                    const summary = formatMessage((0, $jthWj.default).migrateAccountInfo, {
                        application: applicationName
                    });
                    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lnbpL.default), {
                        id: "login-info",
                        "data-testid": testId,
                        children: summary
                    });
                }
            case "existingUserSignupAttempt":
                {
                    const summary = formatMessage((0, $jthWj.default).existingUserSignupAttemptInfo);
                    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lnbpL.default), {
                        id: "login-info",
                        "data-testid": testId,
                        children: summary
                    });
                }
            default:
                return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $lnbpL.default), {
                    id: "login-info",
                    "data-testid": testId,
                    isHidden: true,
                    children: " "
                });
        }
    };
    (0, $91i6m.useEffect)(()=>{
        analyticsClient.stopInitialLoadApdexEvent("viewLoginPage");
    }, [
        analyticsClient
    ]);
    const emailError = ()=>{
        switch(fieldErrors.email){
            case "unknown":
                return intl.formatMessage((0, $jthWj.default).unexpectedErrorHappened);
            case "rate_limit_exceeded_message":
                return intl.formatMessage((0, $jthWj.default).rateLimitErrorMessage);
            default:
                return translatedEmailFieldError;
        }
    };
    const renderExperimentButtons = ()=>{
        if (redirectType === (0, $gtKO2.CheckUserNameRedirectType).Sso) return /*#__PURE__*/ (0, $4ZSso.jsxs)($a2307c23eea04d7f$export$d55ce944e082b58f, {
            children: [
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                    id: "login.form.opening.sso",
                    defaultMessage: "Opening your single sign-on provider"
                }),
                /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9OWP7.default), {})
            ]
        });
        else return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cLysE.default), {
            appearance: "primary",
            id: "login-submit",
            type: "submit",
            isFullWidth: true,
            isDisabled: isSecondStep && isTooManyAttemptsRecaptchaRequired && !captchaValue,
            isLoading: buttonClicked === "submit" && (!!isRedirecting || isLoading || isCheckUsernameLoading),
            children: buttonContent()
        });
    };
    const { formatMessage: formatMessage } = intl;
    return /*#__PURE__*/ (0, $4ZSso.jsxs)("div", {
        children: [
            error && !isLoading && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $31nHY.default), {
                children: error?.message
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)("span", {
                children: [
                    " ",
                    infoContent(),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $4ZSso.jsxs)($a2307c23eea04d7f$export$a7fed597f4b8afd8, {
                id: "form-login",
                "data-testid": "form-login",
                onSubmit: handleSubmit,
                onClick: onFormClick,
                children: [
                    /*#__PURE__*/ (0, $4ZSso.jsxs)($a2307c23eea04d7f$var$InputsWrapper, {
                        children: [
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $dmC2D.default), {
                                fieldViewType: $a2307c23eea04d7f$var$getEmailFieldViewType(restrictedEmail, redirectType, isSecondStep, isLoading),
                                fieldError: emailError(),
                                onChange: onEmailChange,
                                value: email,
                                onEmailClick: onEmailClick,
                                placeholderOverride: formatMessage((0, $jthWj.default).emailPlaceholder),
                                inputRef: inputRef
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9w0eB.default), {
                                isHidden: !isSecondStep,
                                fieldError: passwordFieldError || undefined,
                                onChange: handlePasswordChange,
                                value: password,
                                className: `field-group password-field ${isSecondStep ? "expanded" : "hidden"}`
                            }),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cZAbO.LoginRecaptcha), {}),
                            /*#__PURE__*/ (0, $4ZSso.jsx)((0, $cs6gC.LoginMarketingConsent), {}),
                            showRememberMeCheckbox && redirectType !== (0, $gtKO2.CheckUserNameRedirectType).Sso && /*#__PURE__*/ (0, $4ZSso.jsx)((0, $9X0U9.default), {
                                paddingBlockStart: "space.100",
                                paddingBlockEnd: "space.100",
                                children: /*#__PURE__*/ (0, $4ZSso.jsxs)((0, $c32T7.default), {
                                    direction: "row",
                                    gap: "space.050",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $83IjZ.default), {
                                            testId: "remember-me-checkbox",
                                            isChecked: rememberMeChecked,
                                            onClick: onToggleRememberMeCheckbox,
                                            name: "remember",
                                            label: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                                ...(0, $jthWj.default).rememberMeCheckboxLabel
                                            }),
                                            // During the redirect process (and while loading), we want to disable the checkbox so that the user doesn't interact with the checkbox.
                                            isDisabled: buttonClicked === "submit" && (!!isRedirecting || isLoading || isCheckUsernameLoading)
                                        }),
                                        /*#__PURE__*/ (0, $4ZSso.jsx)((0, $5v178.default), {
                                            // TODO [KIRBY-8737]: once it is available, use prop spacing='compact'
                                            // https://hello.jira.atlassian.cloud/browse/KIRBY-8737
                                            appearance: "info",
                                            iconLabel: formatMessage((0, $jthWj.default).rememberMeMoreInfoLabel),
                                            placement: "right",
                                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                                ...(0, $jthWj.default).rememberMeTooltip
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    renderExperimentButtons(),
                    /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
                        isHidden: !isSecondStep || !isPasswordlessAllowed,
                        children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $j7UeI.StyledSocialLoginButton), {
                            id: "passwordless-button",
                            iconBefore: /*#__PURE__*/ (0, $4ZSso.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bt1Sd))), {
                                label: "email"
                            }),
                            iconAfter: /*#__PURE__*/ (0, $4ZSso.jsx)("span", {
                                style: {
                                    width: 24
                                }
                            }),
                            isFullWidth: true,
                            advisoryEnabled: false,
                            onClick: handlePasswordlessButtonClick,
                            isLoading: buttonClicked === "passwordless" && (!!isRedirecting || isLoading),
                            isDisabled: isTooManyAttemptsRecaptchaRequired && !captchaValue || isLoading || isRedirecting,
                            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $6T9dz.default), {
                                id: "login.form.passwordless.button",
                                defaultMessage: "Log in with email"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $a2307c23eea04d7f$export$2e2bcd8739ae039 = $a2307c23eea04d7f$export$1f58f750f20f344b;

});
parcelRegister("dmC2D", function(module, exports) {

$parcel$export(module.exports, "FieldViewType", function () { return $a37bcfc7af5918f1$export$63009c89ca139043; });
$parcel$export(module.exports, "default", function () { return $a37bcfc7af5918f1$export$2e2bcd8739ae039; });

var $4ZSso = parcelRequire("4ZSso");

var $91i6m = parcelRequire("91i6m");

var $fqDmW = parcelRequire("fqDmW");

var $h89s9 = parcelRequire("h89s9");

var $gFwNN = parcelRequire("gFwNN");

var $gaHKK = parcelRequire("gaHKK");

var $leG06 = parcelRequire("leG06");

var $0wXBc = parcelRequire("0wXBc");

var $tbh94 = parcelRequire("tbh94");

var $e3LqV = parcelRequire("e3LqV");
const $a37bcfc7af5918f1$var$IconButtonWrapper = (0, $fqDmW.default).div`
  padding: 3px;
`;
const $a37bcfc7af5918f1$var$HiddenBorder = (0, $fqDmW.default).div`
  * {
    border: none !important;
  }
`;
const $a37bcfc7af5918f1$var$HideBorderOnReadOnly = ({ isReadOnly: isReadOnly, children: children })=>{
    if (isReadOnly) return /*#__PURE__*/ (0, $4ZSso.jsx)($a37bcfc7af5918f1$var$HiddenBorder, {
        children: children
    });
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $4ZSso.Fragment), {
        children: children
    });
};
var $a37bcfc7af5918f1$export$63009c89ca139043;
(function(FieldViewType) {
    FieldViewType["Editable"] = "editable";
    FieldViewType["ReadOnlyWithEditButton"] = "read-only-with-edit-button";
    FieldViewType["Restricted"] = "restricted";
})($a37bcfc7af5918f1$export$63009c89ca139043 || ($a37bcfc7af5918f1$export$63009c89ca139043 = {}));
const $a37bcfc7af5918f1$var$EmailContainer = ({ fieldError: fieldError, fieldViewType: fieldViewType, onChange: onChange, onEmailClick: onEmailClick, placeholderOverride: placeholderOverride, value: value, inputRef: inputRef })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const isEditable = fieldViewType === "editable";
    const prevIsReadOnly = (0, $0wXBc.usePrevious)(!isEditable);
    (0, $91i6m.useEffect)(()=>{
        if (isEditable && prevIsReadOnly) inputRef.current?.focus();
    }, [
        isEditable,
        prevIsReadOnly,
        inputRef
    ]);
    const handleChange = (e)=>{
        const newValue = e.currentTarget.value;
        onChange(newValue);
    };
    const placeholder = placeholderOverride || formatMessage((0, $gaHKK.default).loginFormUsernamePlaceholder);
    return /*#__PURE__*/ (0, $4ZSso.jsx)((0, $gFwNN.default), {
        children: /*#__PURE__*/ (0, $4ZSso.jsx)($a37bcfc7af5918f1$var$HideBorderOnReadOnly, {
            isReadOnly: !isEditable,
            children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $h89s9.default), {
                id: "username" // used in pollinators - #hot-117637
                ,
                testId: "username" // used in pollinators
                ,
                name: "username",
                autoComplete: "username",
                type: "email",
                placeholder: placeholder,
                label: formatMessage((0, $gaHKK.default).loginFormUsernameLabel),
                autoFocus: isEditable,
                onChange: handleChange,
                isInvalid: !!fieldError,
                invalidMessage: fieldError,
                value: value,
                ref: inputRef,
                isDisabled: !isEditable,
                elemAfterInputExternal: fieldViewType === "read-only-with-edit-button" && /*#__PURE__*/ (0, $4ZSso.jsx)($a37bcfc7af5918f1$var$IconButtonWrapper, {
                    children: /*#__PURE__*/ (0, $4ZSso.jsx)((0, $tbh94.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e3LqV))),
                        label: formatMessage((0, $gaHKK.default).loginFormReadOnlyUsernameAriaLabel),
                        onClick: onEmailClick,
                        appearance: "subtle"
                    })
                })
            })
        })
    });
};
var $a37bcfc7af5918f1$export$2e2bcd8739ae039 = $a37bcfc7af5918f1$var$EmailContainer;

});
parcelRegister("e3LqV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3c623c5bc2fbe74$var$_react = $a3c623c5bc2fbe74$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $a3c623c5bc2fbe74$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a3c623c5bc2fbe74$var$EditIcon = (props)=>/*#__PURE__*/ $a3c623c5bc2fbe74$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.02 19.23a1 1 0 001.18 1.18l3.81-.78-4.21-4.21-.78 3.81zm5.921-2.62l-2.12-2.12L16.306 6h.002l2.121 2.121-8.489 8.49zm9.903-9.903l-2.12-2.122A1.997 1.997 0 0016.308 4c-.512 0-1.024.195-1.415.585l-9.757 9.758 4.95 4.95 9.757-9.758a2 2 0 000-2.828z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$a3c623c5bc2fbe74$var$EditIcon.displayName = "EditIcon";
var $a3c623c5bc2fbe74$var$_default = $a3c623c5bc2fbe74$var$EditIcon;
module.exports.default = $a3c623c5bc2fbe74$var$_default;

});




//# sourceMappingURL=defaultPage.a8eb8007.js.map
